import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { Icon } from '../../icon/icon'
import { rem } from '../../../utils'

type StyledListItemProps = {
  $header?: boolean
  $isTitle?: boolean
  $isLink?: boolean
  $utility?: boolean
  $back?: boolean
  $secondary?: boolean
}

const getListItemBackgroundColor = (props: StyledListItemProps) => {
  if (props.$isTitle)
    return '#ffffff'
  if (props.$header)
    return '#1C1F2A'
  if (props.$back)
    return '#f2f2f2'

  return 'white'
}

export const StyledListItem = styled.li<StyledListItemProps>`
  height: ${props => props.$utility ? rem(52, props.theme) : (props.$isTitle ? rem(102, props.theme) : rem(66, props.theme))};
  width: 100%;
  max-width: unset;
  border-bottom: ${props => props.$utility || props.$back ? '0' : '1px solid rgba(0, 0, 0, 0.25)'};
  background-color: ${getListItemBackgroundColor};
  cursor: ${props => props.$isLink ? 'pointer' : 'auto'};
  padding-left: ${props => props.theme.typography.pxToRem(20)};

  & > div > div > a {
    text-decoration: none;
  }

  .MuiGrid-item {
    width: ${props => props.$utility ? '100%' : 'auto'};
    border-bottom: ${props => props.$utility ? '1px solid rgba(0, 0, 0, 0.25)' : '0'};
    text-decoration: none;
  }
`

export const StyledListItemGrid = styled(Grid)`
  height: 100%;
  padding: 0 ${props => props.theme.typography.pxToRem(22)} 0 ${props => props.theme.typography.pxToRem(10)};

  ${props => props.theme.breakpoints.up(390)} {
    padding: 0 ${props => props.theme.typography.pxToRem(22)} 0 ${props => props.theme.typography.pxToRem(40)};
  }
`

export const StyledListItemUtilityGrid = styled(Grid)`
  height: 100%;
`

export const StyledHeaderText = styled.p<{ $secondary?: boolean }>`
  color: ${props => props.$secondary ? props.theme.palette.common.white : props.theme.palette.primary.main};
  margin: 0 ${props => props.$secondary ? 0 : props.theme.typography.pxToRem(4)} 0 0;
  font-weight: 500;
  line-height: 1;
`

export const StyledCallButton = styled(Button)`
  border: 2px solid ${props => props.theme.palette.secondary.dark};
  font-size: ${props => props.theme.typography.pxToRem(15)};
  margin-right: ${props => props.theme.typography.pxToRem(4)};
  padding: ${props => rem(13, props.theme)} ${props => rem(6, props.theme)} ${props => rem(11, props.theme)};

  ${props => props.theme.breakpoints.up(360)} {
    margin-right: ${props => props.theme.typography.pxToRem(20)};
    padding: ${props => rem(13, props.theme)} ${props => rem(13, props.theme)} ${props => rem(11, props.theme)};
  }
`

export const StyledTextSpan = styled.div`
  display: flex;
  font-size: ${props => props.theme.typography.pxToRem(16)};
  align-items: center;
  column-gap: ${props => props.theme.typography.pxToRem(5)};
  justify-content: space-between;
  width: 100%;

  > a {
    text-decoration: none;

    > p {
      margin-top: 0;
    }
  }
`

export const StyledButton = styled(Button)`
  min-width: unset;
  width: ${props => props.theme.typography.pxToRem(32)};
    
  ${props => props.theme.breakpoints.up(360)} {
    width: unset;
  }
    
  svg {
      g, rect {
          fill: #B9B9B9 !important;
      }
  }  
`

export const StyledCloseIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(34)};
`

export const StyledMenuItemText = styled.p`
  line-height: ${props => props.theme.typography.pxToRem(25)};
  margin: 0;
  color: ${props => props.theme.palette.text.primary};
  font-size: ${props => props.theme.typography.pxToRem(18)};
  font-weight: 500;
`

export const StyledLinkItemText = styled.p<{ $isTitle?: boolean; $isUtility?: boolean }>`
  display: flex;
  line-height: ${props => props.theme.typography.pxToRem(22)};
  color: ${props => props.$isTitle ? props.theme.palette.secondary.dark : props.theme.palette.text.primary};
  font-size: ${props => props.$isTitle ? props.theme.typography.pxToRem(20) : props.theme.typography.pxToRem(18)};
  margin-bottom: ${props => props.$isUtility ? props.theme.typography.pxToRem(10) : 0};
  margin-top: 0;
  transition: color 0.2s ease;
  text-decoration: none;
  font-weight: ${$props => !$props.$isUtility && '500'};
  font-weight: ${props => props.$isTitle ? '700' : '500'};
  ${props => props.$isUtility && 'line-height: 20px;'};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(19)};
  }

  &:hover {
    color: ${props => props.$isTitle ? props.theme.palette.text.primary : props.theme.palette.secondary.dark};
  }
`
